/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

import styled from "styled-components";
import { formatterUS } from "../helpers/moneyFormat";

//Icons
import down_arrow from "../icons/metric/down_arrow.svg";
import up_arrow from "../icons/metric/up_arrow.svg";
import percentage from "../icons/metric/percentage.svg";

const StyledMetric = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: 0px 0px 6px #0000001a;
  border-radius: 8px;
  padding: 2em 1em;
  margin-bottom: 15px;
  .subTitle {
    font-size: 12px;
  }
  .metric_container {
    flex:1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding 0px 20px;
    .metric_content_wrapper{
      p {
        margin: 0;
      }
      .metric_title {
        color: #7b8081;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 10px;
        margin-bottom: 1em;
      }
      .metric_content {
        display: flex;
        font-size: 18px;
        font-weight: 600;
        img {
          margin-right: 0.5em;
        }
      }
      .main {
        font-size: 26px;
        font-weight: 700;
      }
    }
  }
  .metric_container:nth-child(1) {
    border-right: solid 3px #f5f5f5;
  }
`;

const Metric = ({ avgOrders }: any) => {
  return (
    <StyledMetric>
      <div className="metric_container">
        <div className="metric_content_wrapper">
          <p className="metric_title">Monto total de ventas</p>
          <div className="metric_content main">
            <p>{formatterUS.format(avgOrders?.all?.totalInUSD || 0)}</p>
          </div>

          <div style={{ marginTop: "5px" }}>
            <p className="subTitle ">
              T. VIRTUAL : {formatterUS.format(avgOrders?.com?.totalInUSD || 0)}
            </p>
            <p className="subTitle ">
              APP : {formatterUS.format(avgOrders?.app?.totalInUSD || 0)}
            </p>
          </div>
        </div>
      </div>

      <div className="metric_container">
        <div className="metric_content_wrapper">
          <p className="metric_title">Monto promedio de venta</p>
          <div className="metric_content">
            <img src={percentage} alt="icon" />
            <p>{formatterUS.format(avgOrders?.all?.avgTotalInUSD || 0)}</p>
          </div>

          <div style={{ marginTop: "5px" }}>
            <p className="subTitle ">
              T. VIRTUAL :
              {formatterUS.format(avgOrders?.com?.avgTotalInUSD || 0)}
            </p>
            <p className="subTitle ">
              APP : {formatterUS.format(avgOrders?.app?.avgTotalInUSD || 0)}
            </p>
          </div>
        </div>
      </div>

      <div className="metric_container">
        <div className="metric_content_wrapper">
          <p className="metric_title">Monto máximo de venta</p>
          <div className="metric_content">
            <img src={up_arrow} alt="icon" />
            <p>{formatterUS.format(avgOrders?.all?.maxTotalInUSD || 0)}</p>
          </div>

          <div style={{ marginTop: "5px" }}>
            <p className="subTitle ">
              T. VIRTUAL :
              {formatterUS.format(avgOrders?.com?.maxTotalInUSD || 0)}
            </p>
            <p className="subTitle ">
              APP :{formatterUS.format(avgOrders?.app?.maxTotalInUSD || 0)}{" "}
            </p>
          </div>
        </div>
      </div>

      <div className="metric_container">
        <div className="metric_content_wrapper">
          <p className="metric_title">Monto mínimo de venta</p>
          <div className="metric_content">
            <img src={down_arrow} alt="icon" />
            <p>{formatterUS.format(avgOrders?.all?.minTotalInUSD || 0)}</p>
          </div>

          <div style={{ marginTop: "5px" }}>
            <p className="subTitle ">
              {" "}
              T. VIRTUAL :{" "}
              {formatterUS.format(avgOrders?.com?.minTotalInUSD || 0)}
            </p>
            <p className="subTitle ">
              {" "}
              APP : {formatterUS.format(avgOrders?.app?.minTotalInUSD || 0)}
            </p>
          </div>
        </div>
      </div>
    </StyledMetric>
  );
};

export default Metric;
